import { ClickAwayListener, Paper, Typography, withStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useState } from 'react';
import AnotacaoForm from './AnotacaoForm/AnotacaoForm';

const styles = theme => ({
    button: {
        cursor: 'text'
    }
});

function NewAnotacao(props) {
    const { classes } = props;
    const [formOpen, setFormOpen] = useState(false);

    function handleFormOpen() {
        setFormOpen(true);
        document.addEventListener("keydown", escFunction, false);
    }

    function handleFormClose() {
        if (!formOpen) {
            return;
        }
        setFormOpen(false);
        document.removeEventListener("keydown", escFunction, false);
    }

    function handleCreate(note) {
        props.handleChangeAnotacoes(note);
        handleFormClose();
    }

    function escFunction(event) {
        if (event.keyCode === 27) {
            handleFormClose();
        }
    }

    function handleClickAway(ev) {
        const preventCloseElements = document.querySelector(".prevent-add-close");
        const preventClose = preventCloseElements ? preventCloseElements.contains(ev.target) : false;
        if (preventClose) {
            return;
        }
        handleFormClose();
    }

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Paper
                className={clsx(classes.button, "flex items-center w-full max-w-512 mt-8 mb-16")}
                elevation={1}
            >
                {formOpen ? (
                    <AnotacaoForm onCreate={handleCreate} variant="new" />
                ) : (
                    <Typography
                        className="w-full px-16 py-12 font-500 text-16 w-full"
                        color="textSecondary"
                        onClick={handleFormOpen}
                    >
                        Anotações...
                    </Typography>
                )}
            </Paper>
        </ClickAwayListener>
    );
}

export default withStyles(styles, { withTheme: true })(NewAnotacao);
